import { stringValidator } from './string';
const CONFIRMATION_DIGITS_CODE_LENGTH = 6;
const CONFIRMATION_BASE32_ENCODED_CODE_LENGTH = 8;
export const confirmationDigitsCodeValidator = ({ requiredError, lengthError, }) => stringValidator({
    requiredError,
    length: { len: CONFIRMATION_DIGITS_CODE_LENGTH, error: lengthError },
});
export const confirmationBase32EncodedCodeValidator = ({ requiredError, lengthError, }) => stringValidator({
    requiredError,
    length: {
        len: CONFIRMATION_BASE32_ENCODED_CODE_LENGTH,
        error: lengthError,
    },
});
